import { EnumBase } from 'hay-core-react';
class PesquisaRespostaClassificacaoNpsEnum extends EnumBase {
    constructor() {
        super([
            'main.pesquisaresposta.classificacaonps.detrator',
            'main.pesquisaresposta.classificacaonps.neutro',
            'main.pesquisaresposta.classificacaonps.promotor',
        ]);
    }
}

const instance = new PesquisaRespostaClassificacaoNpsEnum();
export default instance;
